import styled, { css } from 'styled-components'

import { BORDER_RADIUS, MEDIA_QUERY } from '../../../styles'

export const Container = styled.div<{ $responsive?: boolean }>`
  display: inline-flex;
  @media ${MEDIA_QUERY.MOBILE} {
    ${({ $responsive }) =>
      $responsive &&
      css`
        width: 100%;
      `}
  }
`

export const Inner = styled.div`
  display: grid;
  grid-template-columns: 43px auto 43px;
  gap: 3px;

  button:nth-child(1) {
  }

  button:nth-last-child(1) {
    &:after {
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
    }
  }

  @media ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`

export const Button = styled.button`
  display: inline-block;
  min-width: 43px;
  height: 44px;
  border-radius: ${BORDER_RADIUS};
  border: 1px solid ${({ theme, disabled }) => (disabled ? theme.colors.icon.disabled : theme.colors.input.active)};
  background-color: ${({ theme, disabled }) => (disabled ? theme.colors.input.disabled : theme.colors.input.white)};
  line-height: 42px;
  cursor: pointer;
  padding: 0;
  position: relative;
  vertical-align: middle;

  &:before {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${({ theme, disabled }) => (disabled ? theme.colors.icon.disabled : theme.colors.input.active)};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  &:after {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${({ theme, disabled }) => (disabled ? theme.colors.icon.disabled : theme.colors.input.active)};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
`
